import { get, post, patch } from '@/helpers/httpHandler';
import { cacheAction } from 'vuex-cache';

export default {
  retrieveUsers: () => get('/users'),

  retrieveUser: (_, user) => get(`/users/${user}`),

  store: (_, user) => post('/users', user),

  update: (_, user) => patch(`/users/${user.id}`, user),

  updateLanguageApp: cacheAction(({ cache }, data) => {
    cache.clear();

    return patch('/app-language-id', data);
  })
};
